import type { OptionDB } from "@project/emerge";
import { Sides } from "@project/emerge-types";
import { Covers } from "../enum/Covers";
import { LTCaseUserOption } from "../enum/LTCaseUserOption";
import { LTProducts } from "../enum/LTProducts";
import type { FlightCaseSettings } from "../interfaces/FlightCaseSettings";
import { createCoverOptions } from "../structure/RackInterior";
import { FlightCaseDefinition } from "./FlightCaseDefinition";

export class Koffer extends FlightCaseDefinition {
  public static getSerializedDefaultVersion(
    optionDb: OptionDB,
  ): FlightCaseSettings {
    const result: FlightCaseSettings =
      FlightCaseDefinition.getSerializedDefaultVersion(optionDb);
    result.type = LTProducts.Koffer;
    result.exteriorOptions.angleSections = optionDb.getByName(
      LTCaseUserOption.AngleSectionType,
      "M1377",
    );
    result.exteriorOptions.profiles = optionDb.getByName(
      LTCaseUserOption.ProfileType,
      "M6102",
    );
    result.exteriorOptions.strength = 6.5;
    result.variableOptions = [];
    result.cuts = [
      {
        offset: 50,
        reference: Sides.TOP,
        groupName: Covers.COVER,
      },
    ];
    result.coverPaddings = createCoverOptions(result.cuts);
    return result;
  }
}
